<template>
    <div class="md:max-w-[46.625rem] md:mx-auto ">
        <!-- 借款title -->
        <div
            v-if="aplCatl===aplCatlCode.PON4300"
            class="md:pt-2.5"
        >
            <Title
                v-if="data"
                :text="$route.meta.pageTitle"
                style-code-page
            />
            <div
                v-else
                class="w-[9rem] mt-7"
            >
                <SkeletonSentence class="w-1/2 " />
                <SkeletonSentence class="w-full" />
            </div>
        </div>
        <!-- 631要保人聯絡資訊/ 640保單變更 -->
        <!-- <TitleTemplate
            v-else-if="aplCatl===aplCatlCode.CONTACT || aplCatl===aplCatlCode.POLICY|| aplCatl===aplCatlCode.ACH"
            :data="data"
        /> -->
        <div
            v-else-if="data"
            class="py-4 md:py-6 md:flex items-center"
        >
            <div class="bg-white hidden md:block w-28 h-28 rounded-full leading-[7rem] text-center flex-shrink-0 mr-5  overflow-hidden ">
                <!-- 只有ACH有失敗的icon，其餘只要有案號的都會是受理成功， -->
                <SvgIcon
                    v-if="aplCatl===aplCatlCode.ACH && !data?.status"
                    icon-name="playlist_add_red"
                    class="hidden md:block flex-shrink-0 w-[7.5rem] h-[7.5rem] mr-5"
                />
                <SvgIcon
                    v-else
                    icon-name="playlist_add_blue"
                    class="hidden md:block flex-shrink-0 w-[7.5rem] h-[7.5rem] mr-5"
                />
            </div>
            <div>
                <Title
                    :text="aplCatl===aplCatlCode.ACH?data.message.title:$route.meta.pageTitle"
                    style-code-page
                    class="md:mb-3"
                />
                <p v-if="aplCatl===aplCatlCode.CONTACT || aplCatl===aplCatlCode.POLICY"
                    class="h4"
                >
                    預計將於{{ data.completeTime }}完成變更，變更完成將以簡訊或email通知予您。
                </p>
                <p v-else-if="aplCatl===aplCatlCode.MULTI_PAY_CHANGE || aplCatl===aplCatlCode.CREDIT_CARD_EXP">
                    後續將進行審核作業，申請結果將以email通知予您。
                </p>
                <p v-else-if="aplCatl===aplCatlCode.CREDIT_CARD_AUTH">
                    後續將進行審核作業，申請結果將以簡訊或email通知予您。
                </p>
            </div>
        </div>
        <SkeletonTitleIcon v-else />

        <transition
            name="opacity"
            mode="out-in"
        >
            <SkeletonFinish v-if="!data" />
            <div
                v-else
                class="ring-1 ring-gray-200 rounded-t-md mb-8"
            >
                <div class="h4 text-white gradient-primary py-2 px-2.5 rounded-t-md md:px-5">
                    申請紀錄
                </div>
                <div class="md:bg-white">
                    <ul class="divide-y divide-dashed h4 ">
                        <li class="px-2.5 pt-1.5 pb-1 text-gray-700 md:px-5">
                            申請日期：{{ data.transDate }}
                        </li>
                        <li class="px-2.5 pt-1.5 pb-1 text-gray-700 md:px-5">
                            受理案號：{{ data.regiNo }}
                        </li>
                        <li
                            v-if="data.fullPolicyNo"
                            class="px-2.5 pt-1.5 pb-1 text-gray-700 md:px-5"
                        >
                            保單號碼：{{ data.fullPolicyNo }}
                        </li>
                        <li
                            v-if="data.insuredName"
                            class="px-2.5 pt-1.5 pb-1 text-gray-700 md:px-5"
                        >
                            被保險人：{{ data.insuredName }}
                        </li>
                        <li class="px-2.5 pt-1.5 pb-1 text-gray-700 md:px-5">
                            申請項目：{{ data.aplCatlText }}
                        </li>
                        <li class="px-2.5 py-2 text-right md:px-5">
                            <span
                                class="text-link"
                                @click="downloadPDF(data.regiNo)"
                            >下載申請紀錄</span>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
        <div class="flex justify-center flex-wrap mb-8">
            <button
                class="btn btn-accent md:bg-white rounded-full order-1 mr-2.5"
                @click="goPage(routeName.RECORD)"
            >
                申請紀錄
            </button>
            <button
                class="btn btn-accent md:bg-white rounded-full order-2"
                @click="goPage(routeName.HOME)"
            >
                回首頁
            </button>
            <ButtonACH
                v-if="aplCatl===aplCatlCode.ACH && data?.status"
                v-model:isLoading="isLoading"
                :regiNo="data.regiNo"
                :aplCatl="data.aplCatl"
            />
        </div>
        <div v-if="data">
            <h5 class="mb-2.5">
                說明
            </h5>
            <DescLoan
                v-if="data.aplCatl===aplCatlCode.PON4300"
                @goPage="goPage"
            />
            <DescPayment
                v-else-if="isEqualPayment && data?.status"
                @goPage="goPage"
            />
            <DescPolicy
                v-else
                @goPage="goPage"
            />
        </div>
        <Loading
            :isLoading="isLoading"
            :text="loadingText"
        />
        <Loading2
            :isLoading="isLoading2"
            :textList="[ 'LOADING....', '請稍候，正在取得資料...', 'LOADING....', '資料載入中...' ]"
        />
    </div>
</template>

<script>
import { ref, inject, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { getCompleteData } from '@/apis/system';
import { getPdfRecordToken } from '@/apis/record.js';
import routeName from '@/router/constant.js';
import Loading from '@/components/Loading.vue';
import Loading2 from '@/components/Loading2.vue';
import Title from '@/components/text/Title.vue';
import SkeletonSentence from '@/components/skeletons/SkeletonSentence.vue';
import SkeletonFinish from './SkeletonFinish.vue';
import SkeletonTitleIcon from './SkeletonTitleIcon.vue';
import aplCatlCode from '@/json/aplCatlCode';
import DescLoan from './DescLoan.vue';
import DescPayment from './DescPayment.vue';
import DescPolicy from './DescPolicy.vue';
import ButtonACH from './ButtonACH.vue';
import codeList from '@/json/codeList.js';
import typeListACH from '@/json/typeListACH';
import { EUDC } from '@/utils/EUDC';

export default {
    components: {
        Title,
        SkeletonSentence,
        SkeletonTitleIcon,
        SkeletonFinish,
        DescPayment,
        Loading,
        Loading2,
        DescPolicy,
        DescLoan,
        ButtonACH
    },
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        const isLoading = ref(false);
        const visiblePopup = ref(false);
        const isLoading2 = ref(false);
        const loadingText = ref('');
        const router = useRouter();
        const data = ref(null);
        const aplCatl = computed(() => store.state.services.aplCatl);
        const isEqualPayment = computed(() => {
            const paymentArray = [aplCatlCode.ACH, aplCatlCode.MULTI_PAY_CHANGE, aplCatlCode.CREDIT_CARD_EXP, aplCatlCode.CREDIT_CARD_AUTH];
            return paymentArray.findIndex(i => i === data.value.aplCatl) > -1;
        });
        const downloadPDF = (regiNo) => {
            isLoading.value = true;
            getPdfRecordToken(regiNo).then((response) => {
                const token = response.data.token;
                const path = process.env.VUE_APP_CONTEXT_PATH;
                const baseUrl = `${window.location.origin}${path}`;
                window.open(baseUrl + '/api/transaction/record/downloadPdf?token=' + token, '_blank');
            }).finally(() => {
                setTimeout(() => {
                    isLoading.value = false;
                }, 500);
            });
            // exportPdfRecord(regiNo).then(res => {
            //     const blob = new Blob(['\ufeff', res], {
            //         type: 'application/pdf;charset=UTF-8',
            //     });
            //     const objectUrl = URL.createObjectURL(blob);
            //     const link = document.createElement('a');
            //     link.href = objectUrl;
            //     link.download = regiNo + '.pdf';
            //     document.body.appendChild(link);
            //     link.click();
            //     URL.revokeObjectURL(objectUrl);
            //     document.body.removeChild(link);
            // }).finally(() => {
            //     isLoading.value = false;
            // });
        };
        const getData = () => {
            let isApiBack = false;
            getCompleteData().then(res => {
                data.value = res.data;
                if (res.data.aplCatl === aplCatlCode.PON4300) {
                    const content = data.value.importantMsg;
                    const params = {
                        title: '重要提醒',
                        content: content,
                        confirmButton: '確認',
                        closeicon: false,
                    };
                    openModal(params);
                }
                store.dispatch('permissions/resetTransactionId');
                if (data.value.insuredName) {
                    EUDC();
                }
            }).catch(() => {
                openModal({
                    id: 'error',
                    title: '很抱歉',
                    content: '系統忙碌中，委託受理未完成，請稍後再試，謝謝。',
                    confirmButton: '確認',
                    closeicon: false
                });
            }).finally(() => {
                isApiBack = true;
                isLoading2.value = false;
                setLoading(false, '');
            });

            // 因為借款的api需要時間較長 增加loading
            setTimeout(() => {
                if (!isApiBack && store.state.services.aplCatl === aplCatlCode.PON4300) {
                    // setLoading(true, '資料載入中...');
                    isLoading2.value = true;
                }
            }, 500);
        };

        const setLoading = (open, text) => {
            isLoading.value = open;
            loadingText.value = text;
        };

        const openModal = (params) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on: {
                    confirm() {
                        $vfm.hide('DialogBase');
                        if (params.id === 'error') {
                            router.push({ name: routeName.HOME });
                        }
                    },
                }
            });
        };

        const goPage = (link) => {
            router.push({
                name: link
            });
        };

        getData();

        return {
            data,
            downloadPDF,
            goPage,
            routeName,
            isLoading,
            isLoading2,
            loadingText,
            aplCatlCode,
            aplCatl,
            visiblePopup,
            isEqualPayment
        };
    }
};
</script>
